<section class="flex justify-content-center align-items-center w-full h-screen">
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="surface-card p-4 shadow-1 border-round w-25rem"
  >
    <div class="text-center mb-5">
      <img
        src="assets/images/main-logo.png"
        alt="Image"
        height="50"
        class="mb-4 mt-5"
      />
      <div class="text-900 text-3xl font-medium mb-3">Reset password</div>
    </div>

    <div>
      <app-input
        [options]="{
          type: 'text',
          containerClass: 'p-mb-0',
          label: 'Email',
          placeholder: 'example@example.com',
          formControlName: 'email'
        }"
      >
      </app-input>
      <app-input-password
        [options]="{
          containerClass: 'p-mb-0',
          label: 'New password',
          formControlName: 'password',
          value: '',
          disabled: false,
          validators: {
            required: true,
            maxLength: 200
          }
        }"
      ></app-input-password>
      <app-input-password
        [options]="{
          containerClass: 'p-mb-0',
          label: 'Confirm password',
          formControlName: 'password_confirmation',
          value: '',
          disabled: false,
          validators: {
            required: true,
            maxLength: 200
          }
        }"
      ></app-input-password>

      <div class="flex align-items-center justify-content-end mb-6">
        <a
          [routerLink]="['../../']"
          class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer"
          >Do you have an account? Sign in.</a
        >
      </div>

      <p-messages [(value)]="toastMessage" [enableService]="true"></p-messages>

      <button
        pButton
        pRipple
        type="submit"
        label="Reset password"
        icon="pi pi-user"
        class="w-full"
      ></button>
    </div>
  </form>
</section>
